import React, { useMemo, useState, useEffect } from 'react';
import { Popover, Checkbox, Button } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { getOrgId } from '../../services/subscription';

export enum PromptFilterType {
  SYSTEM = 'system',
  MY = 'my',
  TEAM = 'others',
}

const FILTER_OPTIONS = [
  { label: 'System prompts', value: PromptFilterType.SYSTEM },
  { label: 'My prompts', value: PromptFilterType.MY },
  { label: 'Team member prompts', value: PromptFilterType.TEAM },
];

interface PromptLibraryFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  style?: React.CSSProperties;
  className?: string;
}

const PromptLibraryFilter: React.FC<PromptLibraryFilterProps> = ({
  value,
  onChange,
  style,
  className,
}) => {
  const [visible, setVisible] = useState(false);
  const [tempValue, setTempValue] = useState<string[]>(value);

  useEffect(() => {
    if (visible) setTempValue(value);
  }, [visible, value]);

  const filteredOptions = useMemo(() => {
    let options = FILTER_OPTIONS;
    if (!getOrgId()) {
      options = options.filter((opt) => opt.value !== PromptFilterType.TEAM);
    }
    return options;
  }, []);

  // Calculate selected count (not all selected)
  const selectedCount =
    value.length > 0 && value.length < filteredOptions.length
      ? value.length
      : 0;

  const content = (
    <div style={{ width: 220 }}>
      <Checkbox.Group
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          marginBottom: 8,
        }}
        value={tempValue}
        onChange={(vals) => setTempValue(vals as string[])}
      >
        {filteredOptions.map((opt) => (
          <Checkbox key={opt.value} value={opt.value} style={{ marginLeft: 8 }}>
            {opt.label}
          </Checkbox>
        ))}
      </Checkbox.Group>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          size="small"
          onClick={() => {
            setTempValue(filteredOptions.map((opt) => opt.value));
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            onChange(tempValue);
            setVisible(false);
          }}
        >
          OK
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={visible}
      onOpenChange={setVisible}
      placement="bottomLeft"
    >
      <Button
        size="small"
        icon={<FilterOutlined />}
        className={`prompt-filter-btn${selectedCount ? ' prompt-filter-btn--active' : ''} ${className || ''}`}
        style={style}
      >
        Filter
        {selectedCount > 0 && (
          <span className="prompt-filter-badge">{selectedCount}</span>
        )}
      </Button>
    </Popover>
  );
};

export default PromptLibraryFilter;
